if (!customElements.get('card-carousel')) {
  customElements.define(
    'card-carousel',
    class CardCarousel extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.track = this.querySelector('.card-carousel__track');
        this.slides = this.track ? this.track.querySelectorAll('.card-carousel__slide') : [];
        if (!this.track || this.slides.length < 2) return;
        this.initialized = true;
        this.hydrated = false;
        this.rafId = null;
        this.dots = this.querySelectorAll('.card-carousel__dots > span');

        this.track.addEventListener('scroll', this.onScroll.bind(this), { passive: true });

        const hydrate = this.hydrate.bind(this);
        ['pointerenter', 'touchstart', 'focusin'].forEach((type) =>
          this.addEventListener(type, hydrate, { once: true, passive: true })
        );

        this.querySelectorAll('.card-carousel__arrow').forEach((button) =>
          button.addEventListener('click', this.onArrowClick.bind(this))
        );
      }

      hydrate() {
        if (this.hydrated) return;
        this.hydrated = true;
        this.track.querySelectorAll('img[data-src]').forEach((image) => {
          if (image.dataset.srcset) image.setAttribute('srcset', image.dataset.srcset);
          if (image.dataset.sizes) image.setAttribute('sizes', image.dataset.sizes);
          image.setAttribute('src', image.dataset.src);
          image.removeAttribute('data-src');
          image.removeAttribute('data-srcset');
          image.removeAttribute('data-sizes');
        });
      }

      onScroll() {
        this.hydrate();
        if (this.rafId) return;
        this.rafId = requestAnimationFrame(() => {
          this.rafId = null;
          const index = Math.min(
            Math.round(Math.abs(this.track.scrollLeft) / this.track.clientWidth),
            this.dots.length - 1
          );
          this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
        });
      }

      onArrowClick(event) {
        this.hydrate();
        const direction = event.currentTarget.name === 'next' ? 1 : -1;
        this.track.scrollBy({ left: direction * this.track.clientWidth });
      }
    }
  );
}
